import StyledTextArea from '@kiosk/timeClock/components/StyledTextarea';
import { Attestation } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AttestationView/attestationView.types';

import { StyledAnimatedRow } from './attestationSpecifyView.styles';
import { ATTESTATION_REASON_MAX_CHARACTERS } from './attestationSpecifyView.constants';

type Props = {
  attestationItem: Attestation;
  onChange: (val: string) => void;
};

const AttestationSpecifyView = ({ attestationItem, onChange }: Props) => {
  return (
    <StyledAnimatedRow>
      <StyledTextArea
        minRows={4}
        maxRows={4}
        placeholder="Add a reason"
        value={attestationItem.text || ''}
        onChange={e => onChange((e.target.value as any) as string)}
        maxLength={ATTESTATION_REASON_MAX_CHARACTERS}
      />
    </StyledAnimatedRow>
  );
};

export default AttestationSpecifyView;
